import dynamic from 'next/dynamic'

const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false })

export const Video = ({ url }: { url: string }) => (
  <div className='max-w-768 mx-auto'>
    <div className='spacer-xs aspect-w-16 aspect-h-9 h-full w-full' key={url}>
      <ReactPlayer url={url} width='100%' height='100%' playing loop muted />
    </div>
  </div>
)
